export enum BuiltinDoorId {
  INT_16XX = "INT_16XX",
  INT_1868 = "INT_1868",
  INT_1880 = "INT_1880",
  INT_18XX = "INT_18XX",
  INT_20XX = "INT_20XX",
  INT_2050 = "INT_2050",
  INT_2068 = "INT_2068",
  INT_24XX = "INT_24XX",
  INT_2468 = "INT_2468",
  INT_2080 = "INT_2080",
  INT_2480 = "INT_2480",
  INT_2668 = "INT_2668",
  INT_26XX = "INT_26XX",
  INT_2680 = "INT_2680",
  INT_30XX = "INT_30XX",
  INT_3080 = "INT_3080",
  INT_30XX_GARAGE = "INT_30XX_GARAGE",
  INT_3068_GARAGE = "INT_3068_GARAGE",
  INT_3068_GARAGE_SC = "INT_3068_GARAGE_SC",
  INT_2868 = "INT_2868",
  INT_2880 = "INT_2880",
  INT_28XX = "INT_28XX",
  INT_32XX = "INT_32XX",
  INTC_16XX = "INTC_16XX",
  INTC_18XX = "INTC_18XX",
  INTC_20XX = "INTC_20XX",
  INTC_24XX = "INTC_24XX",
  INTC_26XX = "INTC_26XX",
  INTC_2680 = "INTC_2680",
  INTC_30XX = "INTC_30XX",
  INTC_28XX = "INTC_28XX",
  INTC_32XX = "INTC_32XX",
  INTL_28XX = "INTL_28XX",
  PKT_16XX = "PKT_16XX",
  PKT_20XX = "PKT_20XX",
  PKT_24XX = "PKT_24XX",
  PKT_26XX = "PKT_26XX",
  PKT_30XX = "PKT_30XX",
  PKT_28XX = "PKT_28XX",
  PKT_32XX = "PKT_32XX",
  BI_40XX = "BI_40XX",
  BI_4068 = "BI_4068",
  BARN_30XX = "BARN_30XX",
  BARN_DBL_3068 = "BARN_DBL_3068",
  BARN_DBL_3080 = "BARN_DBL_3080",
  DBL_30XX = "DBL_30XX",
  DBL_40XX = "DBL_40XX",
  DBL_48XX = "DBL_48XX",
  DBL_50XX = "DBL_50XX",
  DBL_54XX = "DBL_54XX",
  DBL_60XX = "DBL_60XX",
  DBL_64XX = "DBL_64XX",
  DBLC_30XX = "DBLC_30XX",
  DBLC_40XX = "DBLC_40XX",
  DBLC_48XX = "DBLC_48XX",
  DBLC_50XX = "DBLC_50XX",
  DBLC_54XX = "DBLC_54XX",
  DBLC_60XX = "DBLC_60XX",
  DBLC_64XX = "DBLC_64XX",
  DBLF_50XX = "DBLF_50XX",
  DBLF_50XX_15LITE = "DBLF_50XX_15LITE",
  DBLFT_6068 = "DBLFT_6068",
  BYP_30XX = "BYP_30XX",
  BYP_40XX = "BYP_40XX",
  BYP_4068 = "BYP_4068",
  BYP_48XX = "BYP_48XX",
  BYP_50XX = "BYP_50XX",
  BYP_54XX = "BYP_54XX",
  BYP_60XX = "BYP_60XX",
  BYP_64XX = "BYP_64XX",
  EXT_DBL = "EXT_DBL",
  EXT_DBL_LOW = "EXT_DBL_LOW",
  EXT_DBL60_LOW = "EXT_DBL60_LOW",
  EXT_DBL60_HF = "EXT_DBL60_HF",
  EXT_DBL60_LOW_HF = "EXT_DBL60_LOW_HF",
  EXT_SLIDE = "EXT_SLIDE",
  EXT_SLIDE_9068 = "EXT_SLIDE_9068",
  EXT_SLIDE_9080 = "EXT_SLIDE_9080",
  EXT_SLIDE_LOW = "EXT_SLIDE_LOW",
  EXT_SLIDE_4068 = "EXT_SLIDE_4068",
  EXT_SLIDE_4080 = "EXT_SLIDE_4080",
  EXT_SLIDE_5068 = "EXT_SLIDE_5068",
  EXT_SLIDE_5080 = "EXT_SLIDE_5080",
  EXT_SLIDE_6068 = "EXT_SLIDE_6068",
  EXT_SLIDE_6080 = "EXT_SLIDE_6080",
  EXT_SLIDE_7680 = "EXT_SLIDE_7680",
  EXT_SLIDE_7880 = "EXT_SLIDE_7880",
  EXT_SLIDE_8080 = "EXT_SLIDE_8080",
  EXT_SLIDE_10068 = "EXT_SLIDE_10068",
  EXT_SLIDE_10080 = "EXT_SLIDE_10080",
  EXT_SLIDE_12080 = "EXT_SLIDE_12080",
  EXT_SLIDE_15068 = "EXT_SLIDE_15068",
  EXT_SLIDE_12080_3 = "EXT_SLIDE_12080_3",
  EXT_SLIDE_15080 = "EXT_SLIDE_15080",
  EXT_SGL28 = "EXT_SGL28",
  EXT_SGL28_HL = "EXT_SGL28_HL",
  EXT_SGL28_LOW = "EXT_SGL28_LOW",
  EXT_SGL28_LOW_HL = "EXT_SGL28_LOW_HL",
  EXT_SGL = "EXT_SGL",
  EXT_SGL_HL = "EXT_SGL_HL",
  EXT_SGL_LOW_HL = "EXT_SGL_LOW_HL",
  EXT_SGL_ARC = "EXT_SGL_ARC",
  EXT_SGL_ARC_36 = "EXT_SGL_ARC_36",
  EXT_SGL_PORTICO = "EXT_SGL_PORTICO",
  EXT_SGL_PORTICO_96_LOW_ARC = "EXT_SGL_PORTICO_96_LOW_ARC",
  EXT_SGL_PORTICO_104_LOW_ARC = "EXT_SGL_PORTICO_104_LOW_ARC",
  EXT_SGL_PORTICO_118_LOW_ARC = "EXT_SGL_PORTICO_118_LOW_ARC",
  EXT_SGL_PORTICO_46_100_LOW_ARC = "EXT_SGL_PORTICO_46_100_LOW_ARC",
  EXT_SGL_PORTICO_46_110_LOW_ARC = "EXT_SGL_PORTICO_46_110_LOW_ARC",
  EXT_SGL_LOW = "EXT_SGL_LOW",
  EXT_SGL_SEC = "EXT_SGL_SEC",
  EXT_SGL_LOW_SEC = "EXT_SGL_LOW_SEC",
  EXT_SGL_LOW_TRANSOM = "EXT_SGL_LOW_TRANSOM",
  EXT_SGL36 = "EXT_SGL36",
  OPEN_FULL = "OPEN_FULL",
  OPEN_2036 = "OPEN_2036",
  OPEN_2080 = "OPEN_2080",
  OPEN_2280 = "OPEN_2280",
  OPEN_2468 = "OPEN_2468",
  OPEN_2668 = "OPEN_2668",
  OPEN_2680 = "OPEN_2680",
  OPEN_28XX = "OPEN_28XX",
  OPEN_30XX = "OPEN_30XX",
  OPEN_3080 = "OPEN_3080",
  OPEN_3276 = "OPEN_3276",
  OPEN_36XX = "OPEN_36XX",
  OPEN_3680 = "OPEN_3680",
  OPEN_38XX = "OPEN_38XX",
  OPEN_40XX = "OPEN_40XX",
  OPEN_7786 = "OPEN_7786",
  OPEN_88XX = "OPEN_88XX",
  OPEN_120XX = "OPEN_120XX",
  OPEN_12068 = "OPEN_12068",
  OPEN_12080 = "OPEN_12080",
  OPEN_15080 = "OPEN_15080",
  OPEN_ARC_3080 = "OPEN_ARC_3080",
  OPEN_ARC_3468 = "OPEN_ARC_3468",
  OPEN_ARC_3478 = "OPEN_ARC_3478",
  OPEN_ARC_4080 = "OPEN_ARC_4080",
  OPEN_ARC_6080 = "OPEN_ARC_6080",
  OPEN_ARC_7786 = "OPEN_ARC_7786",
  OPEN_ARC_FULL = "OPEN_ARC_FULL",
  OPEN_5068 = "OPEN_5068",
  OPEN_5080 = "OPEN_5080",
  OPEN_50XX = "OPEN_50XX",
  OPEN_60XX = "OPEN_60XX",
  OPEN_30710 = "OPEN_30710",
  OPEN_36710 = "OPEN_36710",
  OPEN_40710 = "OPEN_40710",
  OPEN_80710 = "OPEN_80710",
  OPEN_811_710 = "OPEN_811_710",
  OPEN_186_74 = "OPEN_186_74",
  G_20080 = "G_20080",
  G_10080 = "G_10080",
  G_9070 = "G_9070",
  G_18070 = "G_18070",
  G_18070_2 = "G_18070_2",
  G2 = "G2",
  G2_2 = "G2_2",
  G2_3 = "G2_3",
  G2_4 = "G2_4",
  G1 = "G1",
  G1_2 = "G1_2",
  FIREPLACE = "FIREPLACE",
  CL_BYPASS = "CL_BYPASS",
  NONE = "NONE",
}
